module.exports = __webpack_public_path__ + "assets/cynai-logo-black.8ac95685.svg";